var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-combo-boards-double grid grid--gap-1 banners-count-2" },
    [
      _c("div", { staticClass: "col-12 col-md-6 grid grid--gap-1" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [_c("rb-board-with-fields-on", [_vm._t("banner_left")], 2)],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 overflow-hidden" }, [
          _c(
            "div",
            [
              _c(
                "rb-tiles-wrapper-double",
                { attrs: { "slide-slot": _vm.slideSlotLeft } },
                [_vm._t("tiles_left")],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 grid grid--gap-1" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [_c("rb-board-with-fields-on", [_vm._t("banner_right")], 2)],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 overflow-hidden" }, [
          _c(
            "div",
            [
              _c(
                "rb-tiles-wrapper-double",
                { attrs: { "slide-slot": _vm.slideSlotRight } },
                [_vm._t("tiles_right")],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }